import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navItems = [
    { label: "首页", to: "/" },
    { label: "电影", to: "/category/movie" },
    { label: "电视剧", to: "/category/tv" },
    { label: "演员资讯", to: "/actors" },
    { label: "关于我们", to: "/about" },
  ];

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = keyword.trim();
    if (!trimmed) return;
    setMenuOpen(false);
    navigate(`/search?q=${encodeURIComponent(trimmed)}`);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur-sm border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span
            className={`font-heading font-bold text-xl md:text-2xl ${
              scrolled ? "text-primary-500" : "text-background-50"
            }`}
          >
            色即是空
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`text-sm font-label cursor-pointer transition-colors whitespace-nowrap hover:text-accent-500 ${
                scrolled ? "text-foreground-800" : "text-background-50"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center">
          <form onSubmit={handleSearch} className="relative">
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视 / 演员"
              className={`w-52 lg:w-64 h-9 pl-9 pr-3 rounded-full text-sm border outline-none transition-colors ${
                scrolled
                  ? "bg-background-100 border-background-300 text-foreground-900 placeholder:text-foreground-400"
                  : "bg-background-50/15 border-background-50/40 text-background-50 placeholder:text-background-100"
              }`}
            />
            <button type="submit" className="absolute left-3 top-1/2 -translate-y-1/2 cursor-pointer">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`ri-search-line text-sm ${scrolled ? "text-foreground-500" : "text-background-50"}`}></i>
              </div>
            </button>
          </form>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="菜单"
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-2xl ${scrolled ? "text-foreground-900" : "text-background-50"}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4">
          <form onSubmit={handleSearch} className="relative mb-4">
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视 / 演员"
              className="w-full h-10 pl-9 pr-3 rounded-full text-sm border border-background-300 bg-background-100 text-foreground-900 outline-none"
            />
            <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
              <i className="ri-search-line text-sm text-foreground-500"></i>
            </div>
          </form>
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className="py-3 text-base font-label text-foreground-800 border-b border-background-200 last:border-none cursor-pointer"
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}